import * as React from "react"
import type { SVGProps } from "react"
const SvgStopwatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 3.43a1 1 0 0 1-.71-.29A1 1 0 0 1 9 2.43q0-.43.29-.71a1 1 0 0 1 .71-.3h4q.42 0 .71.3.3.29.29.7c-.01.42-.1.53-.29.72a1 1 0 0 1-.71.29zm2 11q.42 0 .71-.29a1 1 0 0 0 .29-.71v-4a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7v4q0 .44.29.72.29.3.71.29m0 8a9 9 0 0 1-3.49-.71 9 9 0 0 1-2.86-1.94 9 9 0 0 1-1.94-2.86 9 9 0 0 1-.71-3.5q0-1.84.71-3.48a9 9 0 0 1 1.94-2.86 9 9 0 0 1 2.86-1.94A9 9 0 0 1 12 4.43a9 9 0 0 1 2.98.5 10 10 0 0 1 2.67 1.45l.7-.7a1 1 0 0 1 .7-.28q.43 0 .7.28a1 1 0 0 1 .27.7 1 1 0 0 1-.27.7l-.7.7a10 10 0 0 1 1.45 2.67q.5 1.43.5 2.98a9 9 0 0 1-.71 3.49 9 9 0 0 1-1.94 2.86 9 9 0 0 1-2.86 1.94 9 9 0 0 1-3.49.7Zm0-2q2.9 0 4.95-2.05A6.7 6.7 0 0 0 19 13.43q0-2.9-2.05-4.95A6.7 6.7 0 0 0 12 6.43q-2.9 0-4.95 2.05A6.7 6.7 0 0 0 5 13.43q0 2.9 2.05 4.95A6.8 6.8 0 0 0 12 20.43" />
  </svg>
)
export default SvgStopwatch
